import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { getGivingChildGiftsPath, getWriteSponsorshipPath } from '@sola/my-sdk/constants.ts';
import { GiftTypeEnum } from '@sola/schema/dotcom/cart/gift.ts';
import type { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { type GiftEligibility, useGiftEligibility } from '../../utils/gift-availability/use-gift-eligibility.ts';
enum LinkIds {
  gift = '#gift',
  write = '#write',
}
const isGiftContentItem = (item: FlexibleContentProps) => {
  return item.primaryCTA?.link === LinkIds.gift;
};
const departureActionLinks: Record<string, (beneficiaryGlobalId: string) => string> = {
  [LinkIds.gift]: beneficiaryGlobalId => getGivingChildGiftsPath(beneficiaryGlobalId, GiftTypeEnum.Final),
  [LinkIds.write]: getWriteSponsorshipPath
};
export const resolveDepartureOverviewContent = (content: FlexibleContentProps | undefined, beneficiaryGlobalId: string | undefined, giftEligibility: Pick<GiftEligibility, 'isPending' | 'isFinalGiftEligible'>): FlexibleContentProps | undefined => {
  if (!content) {
    return;
  }
  return {
    ...content,
    primaryCTA: undefined,
    secondaryCTA: undefined,
    tertiaryCTA: undefined,
    items: content.items
    // InfoCardMain requires 2 items - if we filter down to 1, then it includes a fake "Placeholder"
    ?.filter(item => {
      if (!isGiftContentItem(item)) {
        return true;
      }
      if (giftEligibility.isPending) {
        return false;
      }
      return giftEligibility.isFinalGiftEligible(beneficiaryGlobalId);
    })?.map(item => {
      const primaryCTA = item.primaryCTA;
      const resolveLink = primaryCTA ? departureActionLinks[primaryCTA.link] : undefined;
      if (!primaryCTA || !resolveLink || !beneficiaryGlobalId) {
        return item;
      }
      return {
        ...item,
        primaryCTA: {
          ...primaryCTA,
          link: resolveLink(beneficiaryGlobalId)
        }
      };
    })
  };
};
export const useDepartureOverview = content => {
  const $ = _c(6);
  const params = useParams();
  const giftEligibility = useGiftEligibility();
  let t0;
  if ($[0] !== params) {
    t0 = params ?? {};
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    globalId
  } = t0;
  let t1;
  if ($[2] !== content || $[3] !== giftEligibility || $[4] !== globalId) {
    t1 = resolveDepartureOverviewContent(content, globalId, giftEligibility);
    $[2] = content;
    $[3] = giftEligibility;
    $[4] = globalId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};